import React from 'react';

export const RealizeConnect = ({ width = 40, height = 40, ...props }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_2148_753)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM10.9849 14.3939V29.3939H11.0606H15.6061V14.6212C15.6061 13.9394 15.8333 13.3333 16.2121 12.9545C16.5909 12.5757 17.1212 12.3485 17.803 12.3485H21.894V8.40906H16.9697C15.0758 8.40906 13.6364 8.93936 12.5758 9.99997C11.5152 11.0606 10.9849 12.5 10.9849 14.3939ZM26.2879 20.7575C27.836 20.7575 29.0909 19.5026 29.0909 17.9545C29.0909 16.4064 27.836 15.1515 26.2879 15.1515C24.7398 15.1515 23.4849 16.4064 23.4849 17.9545C23.4849 19.5026 24.7398 20.7575 26.2879 20.7575ZM29.0909 26.6667C29.0909 28.2148 27.836 29.4697 26.2879 29.4697C24.7398 29.4697 23.4849 28.2148 23.4849 26.6667C23.4849 25.1186 24.7398 23.8636 26.2879 23.8636C27.836 23.8636 29.0909 25.1186 29.0909 26.6667Z"
                    fill="#001D37"
                />
            </g>
            <defs>
                <clipPath id="clip0_2148_753">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
